module.exports = __webpack_public_path__ + "img/logo.229e3eec.png";